import React from "react";
import decodeUnderline from "../utils/decodeUnderline";

interface IProps {
    html?: string[];
}

export default function HtmlWidget(props: IProps) {
    const { html } = props;

    if (typeof html === "undefined") return null;

    return (
        <>
            {html.map((item, i) => (
                <React.Fragment key={i}>
                    <div dangerouslySetInnerHTML={{ __html: decodeHTML(decodeUnderline(item)) }} />
                </React.Fragment>
            ))}
        </>
    );
}

function decodeHTML(html: string) {
    let text = document.createElement("textarea");
    text.innerHTML = html;

    return text.value;
}
